import React from "react";
import { Section, Overline } from "@/components/primitives";
import { NewsletterForm } from "@/components/forms";

export default function NewsletterSection() {
  return (
    <Section className="py-20">
      <div className="relative bg-[#0A1D3D] px-6 sm:px-14 py-16 overflow-hidden">
        <div className="absolute top-0 left-0 h-1 w-24 bg-[#C9A25A]" aria-hidden="true" />
        <Overline className="!text-[#C9A25A]">Newsletter</Overline>
        <h2 className="font-serif-display text-3xl sm:text-5xl font-bold mt-4 max-w-2xl leading-[1.05] text-white tracking-[-0.01em]">
          Ideas Worth Thinking About.
        </h2>
        <p className="text-slate-300 mt-5 max-w-2xl leading-relaxed">
          Practical ideas about thinking, growth, discipline, leadership, relationships and intentional
          living—delivered thoughtfully, not constantly.
        </p>
        <div className="mt-8"><NewsletterForm dark testidPrefix="newsletter-section" /></div>
        <p className="text-xs text-slate-500 mt-4">No spam, no scarcity tactics. Unsubscribe anytime.</p>
      </div>
    </Section>
  );
}
